<div class="tw-w-full tw-aspect-w-16 tw-aspect-h-9">
  <iframe class="tw-w-full" frameborder="0" allowfullscreen [src]="content.embed | safe : 'resourceUrl'"></iframe>
</div>
<div class="tw-mt-3 tw-text-sm tw-text-center tw-text-gray-500" [innerHTML]="content.caption"></div>